import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';

import { PcbTabRoute } from '@/areas/pcb/Pcb/PcbLayout/PcbTabRoute';
import { StackUpPage } from '@/areas/pcb/Pcb/StackUpPage/StackUpPage';
import { assembliesModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/assemblies/$assemblyId/pcb/stackup')({
    staticData: {
        access: { permissions: ['view:assembly'], modulePermissions: assembliesModulePermissions },
        chrome: 'none',
    } satisfies PageStaticData,
    validateSearch: stringSearch({ rfqId: 'required' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <PcbTabRoute tab={StackUpPage} />;
}
